<div class="sales-reports-page">
  <div class="page-header">
    <h1>Sales Reports</h1>
    <p>Track revenue, costs, and profit margins across all completed jobs</p>
  </div>

  @if (isLoading && reports.length === 0) {
    <div class="empty-state">Loading sales reports...</div>
  } @else if (errorMessage && reports.length === 0) {
    <div class="empty-state error">{{ errorMessage }}</div>
  } @else {
    @if (summary) {
      <section class="summary-grid">
        <article class="summary-card blue">
          <span class="summary-label">Total Billed Revenue</span>
          <strong class="summary-value">{{ formatCompactCurrency(summary.totalBilledRevenue) }}</strong>
        </article>

        <article class="summary-card purple">
          <span class="summary-label">Pick Best Revenue</span>
          <strong class="summary-value">{{ formatCompactCurrency(summary.pickBestRevenue) }}</strong>
        </article>

        <article class="summary-card pink">
          <span class="summary-label">AI Enhancement Revenue</span>
          <strong class="summary-value">{{ formatCompactCurrency(summary.enhancementRevenue) }}</strong>
        </article>

        <article class="summary-card orange">
          <span class="summary-label">Cropping Revenue</span>
          <strong class="summary-value">{{ formatCompactCurrency(summary.cropRevenue) }}</strong>
        </article>

        <article class="summary-card green">
          <span class="summary-label">Background Extract Revenue</span>
          <strong class="summary-value">{{ formatCompactCurrency(summary.backgroundExtractionRevenue) }}</strong>
        </article>
      </section>

      <section class="summary-grid" style="margin-top: 16px;">
        <article class="summary-card" style="background: #eef2ff;">
          <span class="summary-label" style="color: #4f46e5;">Total Collected</span>
          <strong class="summary-value" style="color: #312e81;">{{ formatCompactCurrency(summary.totalCollectedRevenue) }}</strong>
        </article>

        <article class="summary-card" style="background: #f0fdfa;">
          <span class="summary-label" style="color: #0d9488;">Advance Collected</span>
          <strong class="summary-value" style="color: #115e59;">{{ formatCompactCurrency(summary.advancePaymentsCollected) }}</strong>
        </article>

        <article class="summary-card" style="background: #fdf4ff;">
          <span class="summary-label" style="color: #c026d3;">Remaining Collected</span>
          <strong class="summary-value" style="color: #86198f;">{{ formatCompactCurrency(summary.remainingPaymentsCollected) }}</strong>
        </article>

        <article class="summary-card" style="background: #fef2f2;">
          <span class="summary-label" style="color: #e11d48;">Refunded</span>
          <strong class="summary-value" style="color: #9f1239;">{{ formatCompactCurrency(summary.refundedAmount) }}</strong>
        </article>

        <article class="summary-card" style="background: #fffbeb;">
          <span class="summary-label" style="color: #d97706;">Outstanding Balance</span>
          <strong class="summary-value" style="color: #92400e;">{{ formatCompactCurrency(summary.outstandingBalance) }}</strong>
        </article>
      </section>
    }

    <div class="reports-card">
      <div class="reports-toolbar">
        <div class="search-box">
          <span class="search-icon">⌕</span>
          <input
            type="text"
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange($event)"
            placeholder="Search reports by job name..."
          />
        </div>

        <button type="button" class="export-btn" (click)="exportToCsv()">
          ⭳ Export
        </button>
      </div>

      <div class="table-scroll">
        <table class="reports-table">
          <thead>
            <tr>
              <th>Job Name</th>
              <th>Pick Best</th>
              <th>AI Enhancement</th>
              <th>Cropping</th>
              <th>Background Extraction</th>
              <th>Total Price</th>
              <th>Advance Paid</th>
              <th>Remaining Paid</th>
              <th>Total Collected</th>
              <th>Refunded</th>
              <th>Outstanding</th>
            </tr>
          </thead>

          <tbody>
            @for (report of reports; track report.jobId) {
              <tr>
                <td class="job-name-cell">{{ report.jobName }}</td>

                <td>
                  <span [class.service-yes]="report.pickBestSelected" [class.service-no]="!report.pickBestSelected">
                    {{ getServiceCellText(report.pickBestSelected, report.pickBestAmount) }}
                  </span>
                </td>

                <td>
                  <span [class.service-yes]="report.aiEnhancementSelected" [class.service-no]="!report.aiEnhancementSelected">
                    {{ getServiceCellText(report.aiEnhancementSelected, report.aiEnhancementAmount) }}
                  </span>
                </td>

                <td>
                  <span [class.service-yes]="report.croppingSelected" [class.service-no]="!report.croppingSelected">
                    {{ getServiceCellText(report.croppingSelected, report.croppingAmount) }}
                  </span>
                </td>

                <td>
                  <span
                    [class.service-yes]="report.backgroundExtractionSelected"
                    [class.service-no]="!report.backgroundExtractionSelected"
                  >
                    {{ getServiceCellText(report.backgroundExtractionSelected, report.backgroundExtractionAmount) }}
                  </span>
                </td>

                <td class="total-price">{{ formatCurrency(report.totalPrice) }}</td>
                <td>{{ formatCurrency(report.advancePaid) }}</td>
                <td>{{ formatCurrency(report.remainingPaid) }}</td>
                <td>{{ formatCurrency(report.totalCollected) }}</td>
                <td>{{ formatCurrency(report.refundedAmount) }}</td>
                <td>{{ formatCurrency(report.outstandingAmount) }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      
      @if (reports.length === 0 && !isLoading) {
        <div class="empty-state">No sales reports found.</div>
      }
    </div>
  }

  @if (showAlert) {
    <div class="modal-overlay" (click)="closeAlert()">
      <div class="validation-alert-modal" (click)="$event.stopPropagation()">
        <div class="alert-modal-icon">⚠️</div>
        <h3>Alert</h3>
        <p class="alert-error-text">{{ alertMessage }}</p>
        <button type="button" class="alert-ok-btn" (click)="closeAlert()">Got It</button>
      </div>
    </div>
  }
</div>